// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__17MGm","image":"App_image__1ZJ7T","info":"App_info__36IZr","blinking":"App_blinking__3jt7m","blinkingText":"App_blinkingText__3O5S7"};